<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zYM7wd/Images/cover.jpg?1685327251390" alt="This image is the cover for the book To Touch the Sky, Leap of Faith"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">To Touch the Sky, Leap of Faith
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Leap of Faith: Book Two</i></b></p><p><em>He can run, but he can’t hide…</em></p> <p>Centuries ago, Hawk made a terrible mistake which has haunted him since. Fear of responsibility and feelings of unworthiness leads him to denying the mate Wha-tay showed him in a vision. So now Hawk runs his bar, has casual sex, and never, ever dates men with blond hair and brown eyes. But then Simon walks into his bar, and the future he’s feared is about to end up in a brawl if Hawk doesn’t do something—fast.</p> <p>Simon Carter has a smart mouth and a bulldog temperament. So when Hawk runs, Simon pursues the sexy man, only to be rejected. Just as Simon decides to give up, someone—or something—visits him to change his mind… and scares him to death. Now Simon is backpedaling, and Hawk is in pursuit.</p> <p>Desperate to reassure Simon and keep him safe, Hawk is forced to reveal his secrets before he’s ready. Can Simon learn to accept things aren’t always as they seem? Is the connection between them strong enough to help Hawk overcome centuries of pain? The only way the two men will move beyond Hawk’s past is for both of them to take a leap of faith.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M.A. Church
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30baf816